import { Component } from 'vue';

enum Routes {
	LOAD_FOR_CAMPAIGN_CREATION = 'load-for-campaign-creation',
	GENERAL = 'general',
	LINKED_ORGANISATIONS = 'linked-organisations',
	ENTITIES_AND_GEOTARGETING = 'entities-and-geotargeting',
	CUSTOM_PRODUCTS = 'custom-products',
	RIGHTS = 'rights',
	INTERNAL_NOTES = 'internal-notes',
	AUDITOR = 'auditor'
}

interface IRouter {
	current: Routes;
	next: Routes | null;
	props: {
		id: number;
		isCampaignCreation: boolean;
	};
}

type TRoutes = {
	[key in Routes]: Component;
};

export { IRouter, TRoutes, Routes };
